import { render, staticRenderFns } from "./LfItemClaims.vue?vue&type=template&id=53cf9436"
import script from "./LfItemClaims.vue?vue&type=script&lang=js"
export * from "./LfItemClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports